import React, { useEffect, useRef } from "react";
import "./SplashScreen.css";

const TYPING_TEXT = "Hello world SlimeTech";
const TYPING_SPEED = 70; // ms par caractère

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const SplashScreen = ({ onComplete, fading }) => {
  const slimeRef   = useRef(null);
  const shadowRef  = useRef(null);
  const laptopRef  = useRef(null);
  const logoRef    = useRef(null);
  const typingRef  = useRef(null);
  const loaderRef  = useRef(null);
  const finalRef   = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const s  = slimeRef.current;
      const sh = shadowRef.current;
      const l  = laptopRef.current;
      const lg = logoRef.current;
      const ty = typingRef.current;
      const ld = loaderRef.current;
      const fn = finalRef.current;
      if (!s) return;

      /* 1 — Slime bounce */
      s.classList.add("sp-slime--active");
      sh.classList.add("sp-shadow--active");
      await sleep(2600);
      if (cancelled) return;

      /* 2 — Slime se transforme */
      s.classList.remove("sp-slime--active");
      s.classList.add("sp-slime--transforming");
      await sleep(650);
      if (cancelled) return;

      /* 3 — Laptop apparaît */
      l.classList.add("sp-laptop--visible");
      await sleep(500);
      if (cancelled) return;

      /* 4 — Logo apparaît */
      lg.classList.add("sp-app-logo--visible");
      await sleep(450);
      if (cancelled) return;

      /* 5 — Effet de frappe */
      ty.textContent = "";
      for (let i = 0; i <= TYPING_TEXT.length; i++) {
        if (cancelled) return;
        ty.textContent = TYPING_TEXT.slice(0, i);
        await sleep(TYPING_SPEED);
      }
      await sleep(900);
      if (cancelled) return;

      /* 6 — Loader */
      ty.classList.add("sp-hidden");
      ld.classList.add("sp-loader--visible");
      await sleep(1900);
      if (cancelled) return;

      /* 7 — Message final — l'utilisateur choisit lui-même où aller */
      ld.classList.remove("sp-loader--visible");
      fn.classList.add("sp-final--visible");
      /* Pas d'auto-fermeture : l'animation attend un clic sur un bouton ou "Passer" */
    };

    run();
    return () => { cancelled = true; };
  }, [onComplete]);

  return (
    <div className={`sp-overlay${fading ? " sp-fading" : ""}`}>

      {/* Bouton passer */}
      <button className="sp-skip" onClick={onComplete}>
        Passer <i className="bi bi-arrow-right" aria-hidden="true" />
      </button>

      <section className="sp-hero" aria-label="Animation de chargement SlimeTech">

        {/* ── Fond technique ── */}
        <div className="sp-tech-bg" aria-hidden="true">
          <div className="sp-grid" />
          <div className="sp-scan-line" />
          <div className="sp-circuit sp-circuit--one" />
          <div className="sp-circuit sp-circuit--two" />
          <div className="sp-orb sp-orb--left" />
          <div className="sp-orb sp-orb--right" />
        </div>

        {/* ── Scène ── */}
        <div className="sp-scene">

          {/* Ombre du slime */}
          <div className="sp-shadow" ref={shadowRef} aria-hidden="true" />

          {/* Slime */}
          <div className="sp-slime" ref={slimeRef} aria-hidden="true">
            <span className="sp-eye sp-eye--left" />
            <span className="sp-eye sp-eye--right" />
            <div className="sp-mouth" />
          </div>

          {/* Laptop */}
          <div className="sp-laptop" ref={laptopRef}>
            <div className="sp-laptop-screen">
              <div className="sp-app-window">

                {/* Topbar */}
                <div className="sp-topbar" aria-hidden="true">
                  <span className="sp-dot" />
                  <span className="sp-dot" />
                  <span className="sp-dot" />
                </div>

                {/* Corps de l'app */}
                <div className="sp-app-body">
                  <img
                    ref={logoRef}
                    className="sp-app-logo"
                    src="/images/logo-slime-tech.png"
                    alt="Logo SlimeTech"
                  />

                  <div className="sp-app-content">
                    {/* Texte de frappe */}
                    <span className="sp-typing" ref={typingRef} />

                    {/* Loader */}
                    <div className="sp-loader" ref={loaderRef}>
                      <div className="sp-loader-slime" aria-hidden="true" />
                      <div className="sp-loader-label">Chargement...</div>
                    </div>

                    {/* Message final */}
                    <div className="sp-final" ref={finalRef}>
                      <div className="sp-final-title">Choisissez votre projet...</div>
                      <span className="sp-final-sub">
                        <button className="sp-nav-btn" onClick={() => { window.dispatchEvent(new CustomEvent("sp-navigate", { detail: "srv-web"  })); onComplete(); }}>Web</button>
                        <span className="sp-bullet"> · </span>
                        <button className="sp-nav-btn" onClick={() => { window.dispatchEvent(new CustomEvent("sp-navigate", { detail: "srv-app"  })); onComplete(); }}>Application</button>
                        <span className="sp-bullet"> · </span>
                        <button className="sp-nav-btn" onClick={() => { window.dispatchEvent(new CustomEvent("sp-navigate", { detail: "srv-api"  })); onComplete(); }}>API</button>
                        <span className="sp-bullet"> · </span>
                        <button className="sp-nav-btn" onClick={() => { window.dispatchEvent(new CustomEvent("sp-navigate", { detail: "srv-auto" })); onComplete(); }}>Automatisation</button>
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* Base du laptop */}
            <div className="sp-laptop-base">
              <div className="sp-brand">
                <img src="/images/logo-slime-tech.png" alt="" aria-hidden="true" />
                <span>SlimeTech</span>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default SplashScreen;
